module.exports = __webpack_public_path__ + "img/img_cover_part3.4bea3263.jpg";